import React from 'react';
import { ThermometerSnowflakeIcon, WindIcon, ActivityIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Enfría',
    description: 'Aplicas un reset térmico rápido para activar el reflejo de inmersión.',
    icon: <ThermometerSnowflakeIcon className="w-8 h-8 text-blue-400" data-id="element-46" />
  }, {
    number: '2',
    title: 'Seda',
    description: 'Usas la respiración de frecuencia lenta para elevar el CO2 y calmar el corazón.',
    icon: <WindIcon className="w-8 h-8 text-blue-400" data-id="element-47" />
  }, {
    number: '3',
    title: 'Suelta',
    description: 'Ejecutas el Escaneo Corporal Inverso para liberar la tensión muscular residual y entrar en sueño profundo.',
    icon: <ActivityIcon className="w-8 h-8 text-blue-400" data-id="element-48" />
  }];
  return <section className="py-16 md:py-24 bg-slate-800 border-y border-slate-700" data-id="element-49">
      <div className="max-w-5xl mx-auto px-4" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-52">
            Cómo funciona el protocolo
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-53">
            Tres pasos físicos simples que puedes hacer desde tu cama para
            forzar la relajación de tu sistema nervioso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-54">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-slate-700 z-0" data-id="element-55" />

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-56">
              <div className="w-24 h-24 rounded-full bg-slate-900 border-4 border-slate-700 flex items-center justify-center mb-6 shadow-xl relative" data-id="element-57">
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm border-2 border-slate-900" data-id="element-58">
                  {step.number}
                </div>
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-59">
                {step.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-60">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}